"use strict";

jQuery(document).on('click', '[js-warn]', function (evt) {
    var msg = $(this).attr('js-warn');
    if (window.confirm(msg)) return true;
    evt.preventDefault();
    return false;
});
